import { render } from "./MetaLogo.vue?vue&type=template&id=5e9770c8"
import script from "./MetaLogo.vue?vue&type=script&lang=js"
export * from "./MetaLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__